import { render, staticRenderFns } from "./CourseResult.vue?vue&type=template&id=63f974b0&scoped=true&"
import script from "./CourseResult.vue?vue&type=script&lang=js&"
export * from "./CourseResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f974b0",
  null
  
)

export default component.exports